import { NgModule } from '@angular/core';
import { ResearchModule } from '../research/research.module';
import { CommonModule } from '@angular/common';
import { GlobalSearchRoutingModule } from './global-search-routing.module';
import { BlastEmailModule } from '../feeds/blastemail/blastemail.module';
import { ContactListModule } from '../contact-list/contact-list.module';

@NgModule({
    imports: [
        CommonModule,
        GlobalSearchRoutingModule,
        ResearchModule,
        ContactListModule,
        BlastEmailModule
    ],
    declarations: [
    ]
})
export class GlobalSearchModule { }
